import { useEffect, useContext } from 'react';
import ejeService from '../services/ejes';
import { GeneralContext } from '../context/GeneralContext';
import { useTranslation } from 'react-i18next';

export const useEjes = () => {
    const { user, ejes, setEjes } = useContext(GeneralContext);
    const { i18n } = useTranslation();

    useEffect(() => {
        ejeService.getAll(user?.language ? user.language : elegirIdioma(i18n.language)).then(data => {
            setEjes(data)
        });
    }, [user]);

    function elegirIdioma(language) {
        switch (language) {
            case "es":
                return "es-ES";
            case "en":
                return "EN";
            case "ca":
                return "ca-ES";
            case "ga":
                return "gl-ES";
            case "eu":
                return "eu-ES";
            case "va":
                return "ca-ES-valencia"
            default:
                return "es-ES";
        }
    }

    return { ejes };
}
